export const PageWithoutSidebar = [
    "/lk/login",
    "/",
    "/lk/login/",
    "/lk/forgotpassword",
    "/lk/forgotpassword/",
    "/lk/registration",
    "/lk/registration/",
    "/lk/faq",
    "/lk/faq/",
    "/lk/registration/phone",
    "/lk/registration/phone/",
    "/lk/registration/mail",
    "/lk/registration/mail/",
    "/lk/registration/mail/",
    "/lk/change-password",
    "/lk/change-password/",
    "/lk/recovery-access",
    "/lk/recovery-access/",
    "/lk/:objectId?/fastCreateObject",
    "/lk/:objectId?/fastCreateObject/",
]



